var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header'),_c('router-view'),_c('Footer'),_c('MobileMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }